module.exports = __webpack_public_path__ + "img/baichang-logo1.5d49b7a7.png";